export const hasFlag = (currentFlags: number, flag: number): boolean => (currentFlags & flag) === flag;

export const hasAnyFlag = (currentFlags: number, flagsToCheck: number): boolean => (currentFlags & flagsToCheck) > 0;

export const addFlag = (currentFlags: number, flag: number): number => currentFlags | flag;

export const removeFlag = (currentFlags: number, flag: number): number => currentFlags & ~flag;

export const setFlag = (currentFlags: number, flag: number, value: boolean): number =>
  value ? addFlag(currentFlags, flag) : removeFlag(currentFlags, flag);
